import { render, staticRenderFns } from "./FbRequests.vue?vue&type=template&id=2fa0a404&scoped=true&"
import script from "./FbRequests.vue?vue&type=script&lang=js&"
export * from "./FbRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0a404",
  null
  
)

export default component.exports